import React from "react";

export function RightArrow(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
      <mask
        id="mask0_3390_30835"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3390_30835)">
        <path
          d="M8.87539 17.1254C8.72539 16.9754 8.65039 16.8004 8.65039 16.6004C8.65039 16.4004 8.72539 16.2254 8.87539 16.0754L12.9504 12.0004L8.87539 7.92539C8.72539 7.77539 8.65039 7.60039 8.65039 7.40039C8.65039 7.20039 8.72539 7.02539 8.87539 6.87539C9.02539 6.72539 9.20039 6.65039 9.40039 6.65039C9.60039 6.65039 9.77539 6.72539 9.92539 6.87539L14.4254 11.3754C14.5087 11.4587 14.5714 11.5544 14.6134 11.6624C14.6547 11.7711 14.6754 11.8837 14.6754 12.0004C14.6754 12.1171 14.6547 12.2294 14.6134 12.3374C14.5714 12.4461 14.5087 12.5421 14.4254 12.6254L9.92539 17.1254C9.77539 17.2754 9.60039 17.3504 9.40039 17.3504C9.20039 17.3504 9.02539 17.2754 8.87539 17.1254Z"
          fill="#1A1A1A"
        />
      </g>
    </svg>
  );
}

export function LeftArrow(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
      <mask
        id="mask0_3390_30831"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3390_30831)">
        <path
          d="M13.4746 17.1254L8.97461 12.6254C8.89128 12.5421 8.82861 12.4461 8.78661 12.3374C8.74528 12.2294 8.72461 12.1171 8.72461 12.0004C8.72461 11.8837 8.74528 11.7711 8.78661 11.6624C8.82861 11.5544 8.89128 11.4587 8.97461 11.3754L13.4746 6.87539C13.6246 6.72539 13.7996 6.65039 13.9996 6.65039C14.1996 6.65039 14.3746 6.72539 14.5246 6.87539C14.6746 7.02539 14.7496 7.20039 14.7496 7.40039C14.7496 7.60039 14.6746 7.77539 14.5246 7.92539L10.4496 12.0004L14.5246 16.0754C14.6746 16.2254 14.7496 16.4004 14.7496 16.6004C14.7496 16.8004 14.6746 16.9754 14.5246 17.1254C14.3746 17.2754 14.1996 17.3504 13.9996 17.3504C13.7996 17.3504 13.6246 17.2754 13.4746 17.1254Z"
          fill="#1A1A1A"
        />
      </g>
    </svg>
  );
}
